import React, { useState, Fragment, useRef } from 'react';
// import { BsCalendarCheck } from "react-icons/bs";
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
import {
  wagonrColors,
  wagonrData,
  wagonrMileage,
  wagonrSliders,
  wagonrVariants,
} from '../../constants/wagonrData';
import Header from '../../components/header/Header';
import { Helmet } from 'react-helmet';
import { CarEnquiryDown } from '../Forms/CarEnquiryDown';
import PriceTable from '../reusable/pricetable';
import CarDetails from '../reusable/cardslider';

function Wagonr() {
  const carEnquiryRef = useRef(null);
  // const scrollToCarEnquiry = () => {
  //   if (carEnquiryRef.current) {
  //     carEnquiryRef.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // };
  return (
    <>
      <Header />
      <Helmet>
        <title>
          Maruti Suzuki WagonR 2025 Summer Discounts – Spacious and Efficient at
          RKS Motor! Exclusive may 2025 Offers on Maruti Suzuki WagonR –
          Limited-Time Summer Deals!
        </title>
        <meta
          name='title'
          content=' Maruti Suzuki WagonR 2025 Summer Discounts – Spacious and Efficient at RKS Motor!  Exclusive may 2025 Offers on Maruti Suzuki WagonR – Limited-Time Summer Deals!'
        />
        <meta
          name='description'
          content=" Enjoy Exclusive may 2025 Summer Discounts on the Maruti Suzuki WagonR at Saboo RKS! Known for its spacious design and efficient performance, the Maruti Suzuki WagonR is now available with special may summer offers and limited-time discounts. Grab the offer before it's gone and drive home the WagonR with amazing savings this season!"
        />

        <meta
          name='keywords'
          content='Maruti WagonR Offer, may 2025 Summer Discounts on Maruti WagonR, WagonR 2025 Summer Offers, Maruti Suzuki WagonR may Deals, WagonR Summer Special Discounts, Maruti Arena WagonR may Offers, 2025 Summer Car Sale WagonR, Maruti WagonR 2025 Limited-Time Summer Offers, WagonR 2025 may Special Discounts, Maruti WagonR Summer Savings, WagonR 2025 Summer Festive Deals, Maruti Suzuki WagonR may Promotions, WagonR may 2025 Savings, Maruti WagonR 2025 Car Offers.'
        />
        <meta name='author' content='Broaddcast' />
        <meta property='og:type' content='website' />
        <meta
          property='og:url'
          content='https://www.saboomaruti.in/maruti-wagon-r-on-road-price-in-hyderabad'
        />
        <meta
          property='og:title'
          content=' Maruti Suzuki WagonR 2025 Summer Discounts – Spacious and Efficient at RKS Motor!  Exclusive may 2025 Offers on Maruti Suzuki WagonR – Limited-Time Summer Deals!'
        />
        <meta
          property='og:description'
          content="Enjoy Exclusive may 2025 Summer Discounts on the Maruti Suzuki WagonR at Saboo RKS! Known for its spacious design and efficient performance, the Maruti Suzuki WagonR is now available with special may summer offers and limited-time discounts. Grab the offer before it's gone and drive home the WagonR with amazing savings this season!"
        />
        <meta property='og:image' content='img/og-tags/wagonr.webp' />
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:url' content='https://x.com/saboorksmaruti' />
        <meta
          property='twitter:title'
          content=' Maruti Suzuki WagonR 2025 Summer Discounts – Spacious and Efficient at RKS Motor!  Exclusive may 2025 Offers on Maruti Suzuki WagonR – Limited-Time Summer Deals!'
        />
        <meta
          property='twitter:description'
          content="Enjoy Exclusive may 2025 Summer Discounts on the Maruti Suzuki WagonR at Saboo RKS! Known for its spacious design and efficient performance, the Maruti Suzuki WagonR is now available with special may summer offers and limited-time discounts. Grab the offer before it's gone and drive home the WagonR with amazing savings this season!"
        />
        <meta property='twitter:image' content='img/og-tags/wagonr.webp' />
      </Helmet>
      <img
        src={require('../../assets/banners/vehicles/banners-2024/Wesbite_Maruti_Suzuki_Arena_WagonR_Waltz_Edition_Saboo_RKS_Motor.webp')}
        alt=' Maruti Suzuki Arena WagonR Waltz Edition Saboo RKS Motor'
        className='hidden w-full mt-14 sm:block'
      />
      <img
        src={require('../../assets/banners/vehicles/banners-2024/Wesbite_Mobile_Maruti_Suzuki_Arena_WagonR_Waltz_Edition_Saboo_RKS_Motor.webp')}
        alt='Mobile Maruti Suzuki Arena WagonR Waltz Edition Saboo RKS Motor'
        className='w-full sm:hidden'
      />

      {/* <img
        src={WagonR}
        className="w-full max-w-full lg:mt-16"
        alt="Buy Maruti Suzuki Wagon r 2024 in Hyderabad"
      /> */}
      <div className='container grid grid-cols-1 gap-5 px-5 mx-auto my-8 sm:grid-cols-2 sm:px-0'>
        <div>
          <ImageGallery
            lazyLoad={true}
            autoPlay={true}
            thumbnailPosition='left'
            showPlayButton={false}
            items={wagonrSliders}
          />
        </div>
        <div className=''>
          <CarDetails {...wagonrData} />
        </div>
      </div>

      <div className='container mx-auto'>
        <div className='mx-5'>
          <div className='flex flex-col lg:flex-row lg:space-x-4'>
            <div className='mb-4 lg:w-1/2 lg:mb-0' ref={carEnquiryRef}>
              <CarEnquiryDown title='WAGON-R' carName='WAGON-R' />
            </div>
            <div className='lg:w-1/2'>
              <Colors />
            </div>
          </div>
          <div className='mt-8 '>
            <PriceTable
              sections={[
                {
                  headers: ['Variants', 'Transmission', 'Price'],
                  columns: ['title', 'transmission', 'price'],
                  rows: wagonrVariants,
                },
                {
                  headers: ['FUELTYPE', 'Transmission', 'Mileage'],
                  columns: ['fueltype', 'transmission', 'mileage'],
                  rows: wagonrMileage,
                },
              ]}
              disclaimer='The prices and
          mileage information provided in the table above are indicative and
          subject to change. The actual prices and mileage of Maruti Suzuki
          vehicles may vary based on factors such as location, dealer, variant,
          and other applicable conditions. For the most accurate and up-to-date
          information, please contact your nearest Saboo RKS Motor Maruti Suzuki
          dealership.'
            />
          </div>
        </div>
      </div>

      <div>
        {' '}
        <img
          src='https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/maruti-wagon-r/new_WagonR_Brochure.webp'
          alt='brochure'
          className='w-full'
        />
      </div>
    </>
  );
}

const Colors = () => {
  const [current, setCurrent] = useState(1);
  return (
    <div className='container flex flex-col items-center py-8 mx-auto mt-16 bg-gray-100 rounded-3xl'>
      {wagonrColors.map((item) => (
        <img
          key={item.id}
          src={item.img}
          className={item.id === current ? 'mx-auto sm:h-80' : 'hidden'}
          alt={item.id}
        />
      ))}
      <div className='flex items-center justify-center space-x-3 space-y-1 sm:space-y-0'>
        <p
          className={`${
            current === 1 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5`}
          style={{
            background:
              'linear-gradient(61deg, rgba(228,41,34,1) 50%, rgba(15,15,15,1) 50%)',
          }}
          onClick={() => setCurrent(1)}
        ></p>
        <p
          className={`${
            current === 2 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5 bg-[#7c6f5f]`}
          onClick={() => setCurrent(2)}
        ></p>
        <p
          className={`${
            current === 3 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5 bg-[#b3b5b0]`}
          onClick={() => setCurrent(3)}
        ></p>
        <p
          className={`${
            current === 4 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5 bg-[#656563]`}
          onClick={() => setCurrent(4)}
        ></p>
        <p
          className={`${
            current === 5 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5 bg-[#68afe4]`}
          onClick={() => setCurrent(5)}
        ></p>
        <p
          className={`${
            current === 6 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5 bg-[#bd0a10]`}
          onClick={() => setCurrent(6)}
        ></p>
        <p
          className={`${
            current === 7 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5`}
          style={{
            background: 'linear-gradient(228deg, #212529 50%, #6c757d 50%)',
          }}
          onClick={() => setCurrent(7)}
        ></p>

        <p
          className={`${
            current === 8 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5 border border-gray-300 bg-[#FFF]`}
          onClick={() => setCurrent(8)}
        ></p>
        <p
          className={`${
            current === 9 ? 'animate-bounce' : ''
          } h-5 rounded-full w-5 border border-black bg-[#080808]`}
          onClick={() => setCurrent(9)}
        ></p>
      </div>
    </div>
  );
};

export default Wagonr;
